import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
	setVeiculeInfos,
	setVeiculeKilo,
	CurrentStepSetAction,
	setFilterDealersBy
} from '../../../actions/action';
import CONSTANTS from "../../../constants";
import TabSection from "./TabSection";
import TabInfoSection from "./TabInfoSection";
import { Input, Button, Radio, Select } from "../../Forms/Forms";
import fetchApiData from '../../apiHandlers/fetchApiData'
import { pushEventToGTM } from '../../../helpers/trackerManager';
import PopUp from '../../popup/popup'
import {
	Link,
} from 'react-router-dom';
import "./Tabs.css";


const mapStateToProps = state => state;
const mapDispatchToProps = { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, setFilterDealersBy };

class ModelTab extends PureComponent {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			showFiltersPopup: false,
			allModels: [],
			allEnergydata: [],
			isActivateRecallCampaign: !!Number(CONSTANTS.SITE_CONFIG.ActivateRecallCampaign),
			MarkInput: CONSTANTS.SITE_INFO.BRAND_CODE,
			ModelInput: '0',
			ModelData: this.loadModels() || {},
			EnableEnergyInput: false,
			EnergyInput: '0',
			EnergyData: {},
			//validFirstSection:true,
			//validSecondeSection:false,
			step1Loading: false,
			//step1ButtonDisabled:true,
			step2ButtonDisabled: true,
			immaInput: "",
			matriculeCodeError: false,
			KilometrageError: false,
			kilometrage: props.store.kilo.kilometrage ? props.store.kilo.kilometrage : "",
			contratSerivce: (Object.values(props.store.kilo).length > 0 && props.store.kilo.contratService ? true : false),
			isVehiclePC: this.props.store.car.PC === undefined ? false : this.props.store.car.PC,
			isVehicleLCV: this.props.store.car.LCV === undefined ? false : this.props.store.car.LCV,
			otherEnergyInput: "",
			otherModelInput: "",
			didChooseOtherModel: false
		};
		this.isActivateFiltersVPVU = this.props.store.listPremiumServices.some(item =>
			(item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL);
		let selectedModelOrMotor = {};
		this.loadModels = this.loadModels.bind(this);
		this.loadMotos = this.loadMotos.bind(this);
		this.validStep = this.validStep.bind(this);
	}
	componentDidMount() {
		console.log(this.isActivateFiltersVPVU)
		this._isMounted = true;
		this.setState({
			ModelInput: this.props.prevData.ModelInput,
			EnergyInput: this.props.prevData.EnergyInput,
			step2ButtonDisabled: (Object.values(this.props.store.kilo).length ? false : true)
		});
		if (this.props.prevData.ModelInput !== undefined)
			this.loadMotos(this.props.prevData.ModelInput);


		//Si le modèle est autre, préremplir les infos
		if (
			(this.props.store.car.BrandCode === "O" || !this.props.store.car.MotorCode)
			&& this.props.prevData.EnergyInput !== undefined
			&& this.props.prevData.ModelInput !== undefined) {
			this.setState({ 'MarkInput': 'O' });
			this.setState({ EnergyInput: this.props.store.car.EnergyLabel })
			this.setState({ ModelInput: this.props.store.car.ModelLabel })
			this.setState({ 'didChooseOtherModel': true });
		}
		else { //Si peugeot à Autre
			this.setState({ EnergyInput: this.props.store.car.MotorCode })
			this.setState({ ModelInput: this.props.store.car.ModelCode })
		}
		this.setState({ 'step1Loading': true });
	}

	componentWillUnmount() {
		this._isMounted = false;

	}

	loadModels() {

		const ModelsDetails = new fetchApiData();
		ModelsDetails.getModels().then(
			data => {
				if (this._isMounted) {
					let Data = [];
					Data['0'] = '- ' + CONSTANTS.LABELS.vehicule_model_select_option;

					if (data.d.length) {
						this.setState({ allModels: data.d })
						data.d.map(function (item) {
							Data[item.Value] = item.Text;
						});
					}
					this.setState({ ModelData: Data, step1Loading: false });
				}
			})
			.catch(error => {
				console.log('Error: ', error);
				this.setState({ 'step1Loading': false });
			});
	}
	// this is for loading energie/Motos
	loadMotos(motoCode) {
		const MotosDetails = new fetchApiData();
		this.setState({ step1Loading: true });
		MotosDetails.getMotos(motoCode).then(
			data => {
				let Data = [];
				Data[0] = '- ' + CONSTANTS.LABELS.vehicule_model_select_option;
				if (data.d.length) {
					//this.setState({validFirstSection:false,step1Loading:false}); 
					this.setState({ allEnergydata: data.d })
					data.d.map(function (item) {
						Data[item.Value] = item.Text;
					});
				}
				this.setState({ step1Loading: false, EnergyData: Data });
			})
			.catch(error => {
				console.log('Error: ', error)
				this.setState({ step1Loading: false });
			});
	}
	validStep() {
		if (this.isActivateFiltersVPVU && this.state.MarkInput != 'O') {
			if (CONSTANTS.SITE_INFO.BRAND_CODE !== 'V') {
				this.selectedModelOrMotor = this.state.allModels.filter(model => model.Value === this.state.ModelInput);
				if (!((this.selectedModelOrMotor[0].PC === this.props.store.dealer.PC) || (this.selectedModelOrMotor[0].LCV === this.props.store.dealer.LCV))) {
					this.setState({ showFiltersPopup: true })
					this.setState({
						isVehicleLCV: this.selectedModelOrMotor[0].LCV,
						isVehiclePC: this.selectedModelOrMotor[0].PC
					})
					document.body.classList.add('no-scroll')
				} else this.props.CurrentStepSetAction(4);
			}
			else if (CONSTANTS.SITE_INFO.BRAND_CODE === 'V') {
				this.selectedModelOrMotor = this.state.allEnergydata.filter(motorEnergy => motorEnergy.Value === this.state.EnergyInput);
				if (!((this.selectedModelOrMotor[0].PC === this.props.store.dealer.PC) || (this.selectedModelOrMotor[0].LCV === this.props.store.dealer.LCV))) {
					this.setState({ showFiltersPopup: true })
					this.setState({
						isVehicleLCV: this.selectedModelOrMotor[0].LCV,
						isVehiclePC: this.selectedModelOrMotor[0].PC
					})
					document.body.classList.add('no-scroll')
				} else this.props.CurrentStepSetAction(4);
			}
		}
		else {
			this.props.CurrentStepSetAction(4);
		}
		this.props.setVeiculeInfos({
			"PC": (this.isActivateFiltersVPVU && this.state.MarkInput != 'O') ? this.selectedModelOrMotor[0].PC : false,
			"LCV": (this.isActivateFiltersVPVU && this.state.MarkInput != 'O') ? this.selectedModelOrMotor[0].LCV : false,
			"Mileage": null,
			"SerialNumber": "",
			"HasServiceContract": null,
			"BrandLabel": window.siteConfig.brand,
			"BrandCode": this.state.MarkInput,
			"ModelCode": (this.state.MarkInput != 'O' ? this.state.ModelInput : ''),
			"ModelLabel": (this.state.MarkInput != 'O' ? this.state.ModelData[this.state.ModelInput] : this.state.ModelInput),
			"EnergyLabel": (this.state.MarkInput != 'O' ? this.state.EnergyData[this.state.EnergyInput] : this.state.EnergyInput),
			"MotorCode": (this.state.MarkInput != 'O' ? this.state.EnergyInput : ''),
			//	"MotorLabel": (this.state.MarkInput != 'O' ? this.state.EnergyData[this.state.EnergyInput] : this.state.EnergyInput),
			"Lcdv": "",
			"Registration": "",
		});
		//this.setState({validFirstSection:false})

	}
	continueToNextStep() {
		this.setState({
			showFiltersPopup: false
		});
		document.body.classList.remove('no-scroll')

		this.props.CurrentStepSetAction(4)
		//  pushEventToGTM({
		// 	pageName: 'car-details',
		// 	eventAction: 'Redirection::Internal::Next_step',
		// 	eventLabel: 'model'
		// });

	}
	goToDealersLocator = () => {
		this.props.store.listPremiumServices.forEach(item => {
			if (item.codeIntern === 'LCV' && this.state.isVehicleLCV) {
				if (this.props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
					this.props.setFilterDealersBy([...this.props.store.filterDealersBy, item.idServicePremium])
				}
			}
			if (item.codeIntern === 'PC' && this.state.isVehiclePC) {
				if (this.props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
					this.props.setFilterDealersBy([...this.props.store.filterDealersBy, item.idServicePremium])
				}
			}
		})
		this.props.CurrentStepSetAction(1)
	}

	render() {
		const { ModelLabel, EnergyLabel } = this.props.store.car;
		const { brand, currentBrand } = window.siteConfig;
		const brandChoices = { [currentBrand]: (brand.toLowerCase() === "citroen" ? "Citroën" : brand), 'O': CONSTANTS.LABELS.vehicule_model_select_other };
		const popInFilterContent = <div className='warning-filters'>
			<p className='warning-main'>{CONSTANTS.LABELS.vehicule_filter_alert_main}</p>
			<div className='warning-list'>
				<p className='warning-second'>{CONSTANTS.LABELS.vehicule_filter_alert_second}</p>
				<li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_warranty} </span> </li>
				<li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_maintenance}</span></li>
				<li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}</span></li>
				<li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_package}</span></li>
			</div>
		</div>


		return (<div className="CarDetails-tab-item ModelTab">
			{this.state.isActivateRecallCampaign && <p tabIndex="0" style={{ marginLeft: 30 }} dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_step2recalleligibilitywarning) }}></p>}

			<p tabIndex="0" className="section-intro" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_label1) }}></p>

			<TabSection
				//order={1}
				title={CONSTANTS.LABELS.vehicule_model_step1}
				//editMode={!this.state.validFirstSection}
				//enabled={this.state.validFirstSection}
				//EditClick={()=>this.setState({validFirstSection:true})}
				Loading={this.state.step1Loading}>
				{/*this.state.validFirstSection && */ <React.Fragment>
					<div className="ligne mark-selection">
						<div className="row section-label">
							<span>{CONSTANTS.LABELS.vehicule_model_step1_label_brand}</span>
						</div>

						<div className="row section-form">
							<Select
								Options={brandChoices}
								Selected={this.state.MarkInput}
								Name="mark"
								ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_brand}
								onChange={(e) => {
									this.setState({ MarkInput: e.target.value })
									//Si Peugeot à autre
									if (e.target.value === "O") {
										// Vérifier si la personne est passée par modèle initialement
										if (this.props.store.car.BrandLabel !== null && this.props.store.car.BrandLabel !== "O") {
											//Vérifier si Toujours Opel
											if (this.state.didChooseOtherModel === false) {
												//Ne pas afficher les infos du modele dans autre
												this.setState({ EnergyInput: "" })
												this.setState({ ModelInput: "" })
											}
											else {
												//Si la personne a choisi un autre modele, afficher les infos
												this.setState({ EnergyInput: this.props.store.car.EnergyLabel })
												this.setState({ ModelInput: this.props.store.car.ModelLabel })
											}
										}

										else {
											this.setState({ EnergyInput: this.props.store.car.EnergyLabel })
											this.setState({ ModelInput: this.props.store.car.ModelLabel })
										}
									}
									else { //Si autre à peugeot
										this.setState({ EnergyInput: this.props.store.car.MotorCode })
										this.setState({ ModelInput: this.props.store.car.ModelCode })
									}
								}
								}
							/>

						</div>
					</div>
					<div className="ligne model-selection">
						<div className="row section-label">
							<span>{CONSTANTS.LABELS.vehicule_model_step1_label_model}</span>
						</div>

						<div className="row section-form">

							{(this.state.MarkInput != 'O' ?
								<Select
									Options={this.state.ModelData}
									Selected={this.state.ModelInput || '0'}
									ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_model}
									onChange={(e) => {

										if (e.target.value.trim() !== "0") {
											this.loadMotos(e.target.value);
											this.setState({ ModelInput: e.target.value, EnergyInput: '0' });
										}

										this.props.dataFromChild({
											EnergyInput: false,
											ModelInput: e.target.value,
										});

									}
									}
								/>
								:
								<Input
									placeholder=""
									ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_model}
									onChange={(e) => {
										this.props.dataFromChild({
											EnergyInput: false,
											ModelInput: e.target.value,
										});
										this.setState({ ModelInput: e.target.value });
									}}
									Value={this.state.ModelInput}
								/>
							)}
						</div>
					</div>

					<div className="ligne energy-selection">
						<div className="row section-label">
							<span>{CONSTANTS.LABELS.vehicule_model_step1_label_energy}</span>
						</div>

						<div className="row section-form">

							{(this.state.MarkInput != 'O' ?
								<Select
									Options={this.state.EnergyData}
									Disabled={this.state.ModelInput == '0'}
									ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
									Selected={this.state.EnergyInput || '0'}
									onChange={(e) => {
										this.setState({ EnergyInput: e.currentTarget.value });
										this.props.dataFromChild({
											EnergyInput: e.currentTarget.value,
											ModelInput: this.state.ModelInput,
										});

									}
									}
								/>
								:
								<Input
									placeholder=""
									ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
									onChange={(e) => {
										this.setState({ EnergyInput: e.target.value })

									}}
									Value={this.state.EnergyInput}
								/>
							)}
						</div>
					</div>

					<div className="ligne kilometrage">
						<div className="row section-label">
							<span>{CONSTANTS.LABELS.vehicule_step2_km1}</span>
						</div>

						<div className="row section-form">
							<Input name="distance"
								Type="tel"
								Selected={this.state.kilometrage}
								ariaLabel={CONSTANTS.LABELS.vehicule_step2_km1}
								onChange={(e) => {

									this.setState({ kilometrage: e.target.value });

									if (e.target.value.trim().length
										&& (Number(e.target.value) > 999999 || e.target.value.trim().length > 6)
									) {
										this.setState({
											step2ButtonDisabled: true,
											KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
										})
									} else if (
										e.target.value.trim().length
										&& !(/^[0-9]*$/.test(e.target.value))
									) {
										this.setState({
											step2ButtonDisabled: true,
											KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_numbersonly
										})
									}
									else if (e.target.value.trim().length &&
										Number(e.target.value) === 0) {
										this.setState({
											step2ButtonDisabled: true,
											KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_zero
										})
									}

									else {
										this.setState({ step2ButtonDisabled: false, KilometrageError: false })
									}



								}}

								isInvalid={this.state.KilometrageError}>{CONSTANTS.LABELS.vehicule_step2_km2}</Input>
						</div>
					</div>
					<div className="ligne service-contract">
						<div className="row section-label">
							<span tabIndex="0">{CONSTANTS.LABELS.vehicule_step2_warranty}</span>
						</div>
						<div className="row section-form">
							<Radio name="servieContract" id="servieContract-0" label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={(!this.state.contratSerivce ? true : false)} onChange={(e) => { this.setState({ contratSerivce: false }) }} />
							<Radio name="servieContract" id="servieContract-1" label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={(this.state.contratSerivce ? true : false)} onChange={(e) => { this.setState({ contratSerivce: true }) }} />
						</div>
					</div>
					

					<div className="ligne ">
						<div className="row section-form">
						</div>
						<div className="row section-form">
							<div className="form-wrapper">

								<Button
									onClick={() => {

										this.validStep();
										this.props.setVeiculeKilo({ contratService: this.state.contratSerivce, kilometrage: this.state.kilometrage, carStep: '3' })
										this.props.updateServicesAfterDataChanged();
										pushEventToGTM({
											pageName: 'car-details',
											eventAction: 'Redirection::Internal::Next_step',
											eventLabel: 'model'
										});

									}}
									Disabled={this.state.step2ButtonDisabled ||
										this.state.kilometrage.length < 1 ||
										this.state.EnergyInput == "0" ||
										this.state.EnergyInput == "" ||
										this.state.ModelInput == "0" ||
										this.state.ModelInput == ""}
								>{CONSTANTS.LABELS.common_v2_nextstep}</Button>
							</div>
						</div>
					</div>

					{ // filter LCV/PC incompatibility between vehicle and dealer
						this.state.showFiltersPopup &&
						<PopUp title={CONSTANTS.LABELS.vehicule_filter_alert_title}
							content={popInFilterContent}
							primaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_other_dealer}
							secondaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_ignore}
							handlePrimaryButton={() => this.goToDealersLocator()}
							handleSecondaryButton={() => { this.continueToNextStep('filterPopin') }} />
					}


					{/**
								<div className="row section-infos">
									<TabInfoSection
									title="Où trouver le numéro d'immatriculation ?"
									description="Le numéro d'immatriculation est inscrit sur la carte grise du véhicule."
									/>
								</div>
								**/}
				</React.Fragment>}
				{/* {!this.state.validFirstSection && <React.Fragment>
								<div className="section-summaryBlock" >
										<p className="section-intro">{CONSTANTS.LABELS.vehicule_step2_title} 
                            			<strong>{ this.state.MarkInput != 'O' && CONSTANTS.SITE_INFO.BRAND_NAME} {ModelLabel} - {MotorLabel}</strong></p>
              					  </div>
 								</React.Fragment>} */}
			</TabSection>
			{/* <TabSection
								order={2}
								title="Informations complémentaires"
								enabled={this.state.validFirstSection}
								>
								<div className="ligne">
									<div className="row section-label">
										<span>{CONSTANTS.LABELS.vehicule_step2_km1}</span>
									</div>
									
									<div className="row section-form">
										<Input name="distance"
										Type="tel"
										Selected={this.state.kilometrage}
										onChange={(e)=>{

											this.setState({kilometrage:e.target.value});

											if(e.target.value.trim().length 
												&& Number(e.target.value) > 999999
											  ){
												this.setState({ 
													step2ButtonDisabled: true, 
													KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers 
												})
											}else if ( 
												e.target.value.trim().length   
												&& !(/^[0-9]*$/.test(e.target.value))
												){
												this.setState({
													step2ButtonDisabled:true,
													KilometrageError:CONSTANTS.LABELS.vehicule_step2_error_numbersonly
												})
											}else{
												this.setState({step2ButtonDisabled:false,KilometrageError:false})
											}
										  


									}}
										
										isInvalid={this.state.KilometrageError}>{CONSTANTS.LABELS.vehicule_step2_km2}</Input>
									</div>
								</div>
								<div className="ligne service-contract">
									<div className="row section-label">
										<span>{CONSTANTS.LABELS.vehicule_step2_warranty}</span>
									</div>
									<div className="row section-form">
										<Radio name="servieContract" id="servieContract-0" label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={(!this.state.contratSerivce ? true : false)} onChange={(e)=>{this.setState({contratSerivce:false})}} />
										<Radio name="servieContract" id="servieContract-1" label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={(this.state.contratSerivce ? true : false)} onChange={(e)=>{this.setState({contratSerivce:true})}} />
									</div>
								</div>
								<div className="ligne">
									<div className="row section-label">
									</div>
									<div className="row section-form">
										<div className="form-wrapper">
 											<Button
												 linkTo={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
												onClick={()=>{
												 this.props.CurrentStepSetAction(4);

												this.props.setVeiculeKilo({contratService: this.state.contratSerivce,kilometrage:this.state.kilometrage,carStep:'3'})
												this.props.updateServicesAfterDataChanged();
												pushEventToGTM({pageName:'car-details',
                                                 eventAction: 'Redirection::Internal::Next_step',
                                                 eventLabel:'model'
                                               });
												}}
											Disabled={this.state.step2ButtonDisabled}
											>{CONSTANTS.LABELS.common_v2_nextstep}</Button>
 									</div>
								</div>
							</div>
							</TabSection> */}
		</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelTab);
